import React from 'react';
export default function EmptyComment({
  text
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "header",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "empty-comment",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family
    }
  }, "No comments to display"), /*#__PURE__*/React.createElement("div", {
    className: "quote"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dash",
    style: {
      borderBottomColor: text.body_color
    }
  }));
}